import { fetchApi } from '../client';

export interface RazorpayOrderResponse {
  orderId: string;
  paymentOrderId: string;
  amountPaise: number;
  currency: string;
  keyId: string;
  clinicId: string;
}

export interface PaymentVerifyRequest {
  razorpayOrderId: string;
  razorpayPaymentId: string;
  razorpaySignature: string;
}

export interface RazorpayStatus {
  /** Whether the Payment Gateway add-on is enabled for this clinic — see PaymentGatewayAddonController. */
  addonEnabled: boolean;
  /** addonEnabled AND the clinic has a CONNECTED gateway account — the real "can we take a payment" answer. */
  configured: boolean;
}

/** Staff-collected (front-desk) online payments — see paymentsPatientModule for patient self-pay. */
export const paymentsModule = {
  getStatus: () =>
    fetchApi<RazorpayStatus>('/api/payments/razorpay/status'),

  createOrder: (billId: string, idempotencyKey?: string) =>
    fetchApi<RazorpayOrderResponse>('/api/payments/razorpay/orders', {
      method: 'POST',
      body: JSON.stringify({ billId, idempotencyKey }),
    }),

  verifyPayment: (payload: PaymentVerifyRequest) =>
    fetchApi<{ message: string }>('/api/payments/razorpay/verify', {
      method: 'POST',
      body: JSON.stringify(payload),
    }),
};
